export default function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/emoji-mart/dist-es/polyfills/classCallCheck.js
// module id = 30
// module chunks = 0